import { Routes } from '@angular/router';
import { HomeComponent } from './core/layout/pages/home/home.component';
import { QuotesComponent } from './core/layout/pages/translation-manager/quotes/quotes.component';
import { NgsComponent } from './core/layout/pages/ngs/ngs.component';
import { VendorTranslationComponent } from './core/layout/pages/vendor-translation/vendor-translation.component';
import { TranslationManagerComponent } from './core/layout/pages/translation-manager/translation-manager.component';
import { JobDetailComponent } from './core/layout/pages/translation-manager/job-detail/job-detail.component';
import { AdminComponent } from './core/layout/pages/admin/admin.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { adminGuard } from './core/auth/guards/admin.guard';
import { LoginComponent } from './core/auth/pages/login/login.component';
import { CallbackComponent } from './core/auth/pages/callback/callback.component';
import { LogoutComponent } from './core/auth/pages/logout/logout.component';
import { RedirectComponent } from './core/auth/pages/redirect/redirect.component';
import { unsavedChangesGuard } from './core/auth/guards/unsaved-changes.guard';

export const routes: Routes = [
  // Auth routes (no guard)
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'callback',
        component: CallbackComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'redirect',
        component: RedirectComponent,
      },
    ],
  },
  // Protected application routes
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'my-quotes',
    component: QuotesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'ngs',
    component: NgsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'vendor-translation',
    component: VendorTranslationComponent,
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { breadcrumb: 'New Quote Request' },
  },
  {
    path: 'translation-manager',
    component: TranslationManagerComponent,
    canActivate: [authGuard],
  },
  {
    path: 'translation-manager/:jobUid',
    component: JobDetailComponent,
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [authGuard, adminGuard],
  },
  {
    path: '**', 
    redirectTo: 'home', 
    pathMatch: 'full' 
  },
];
